'use client';

import React, { memo, useLayoutEffect, useRef } from 'react';

const GTRANSLATE_SETTINGS: Record<string, unknown> = {
  default_language: 'fr',
  native_language_names: true,
  detect_browser_language: true,
  languages: ['fr', 'en', 'es', 'it', 'ar', 'zh-CN', 'pt'],
  wrapper_selector: '.gtranslate_wrapper',
  flag_size: 16,
  flag_style: '3d',
  alt_flags: { en: 'usa' },
  horizontal_position: 'inline',
};

function loadGTranslateScript() {
  if (typeof window === 'undefined') return;
  (window as Window & { gtranslateSettings?: typeof GTRANSLATE_SETTINGS }).gtranslateSettings =
    GTRANSLATE_SETTINGS;

  if (document.querySelector('script[data-gt-flags]')) return;
  const s = document.createElement('script');
  s.src = 'https://cdn.gtranslate.net/widgets/latest/flags.js';
  s.async = true;
  s.setAttribute('data-gt-flags', '1');
  document.body.appendChild(s);
}

/* memo : évite que React vide le nœud quand le Header re-rend (scroll / menu). */
export const GTranslateIsland = memo(function GTranslateIsland() {
  const didLoad = useRef(false);

  useLayoutEffect(() => {
    if (didLoad.current) return;
    didLoad.current = true;
    loadGTranslateScript();
  }, []);

  return (
    <div
      className="gtranslate_slot gtranslate_wrapper gtranslate_wrapper--compact shrink-0"
      aria-label="Choisir la langue"
    />
  );
});
